import React from "react"

import Input from "components/Input/Input"
import Button from "components/Button/Button"
import validation_schema from "validator/change-password"
import { useFormik } from "formik"
import UPDATE_PASSWORD from "mutations/update-password"
import { toast } from "react-toastify"
import { useMutation } from "@apollo/client"
import { aquireCustomerId } from "utils/functions"

const MyAccountDetailsFormPass = () => {
  const [updateUser, { loading }] = useMutation(UPDATE_PASSWORD, {
    onCompleted: async () => {
      toast.success("Zaktualizowano hasło")
      formik.resetForm();
    },
    onError: error => {
      if (error) {
        toast.error("Wystąpił błąd")
        console.warn(error)
      }
    },
  })

  const formik = useFormik({
    initialValues: {
      newPass: "",
      newPassRepeat: "",
    },
    validationSchema: validation_schema,
    onSubmit: data => {
      updateUser({
        variables: {
          password: data?.newPass,
          id: aquireCustomerId(),
        },
      })
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-md-6">
          <Input
            placeholder="Nowe hasło"
            type="password"
            id="newPass"
            name="newPass"
            value={formik.values.newPass}
            onChange={formik.handleChange}
          />
        </div>
        <div className="col-md-6">
          <Input
            placeholder="Powtórz nowe hasło"
            type="password"
            id="newPassRepeat"
            name="newPassRepeat"
            value={formik.values.newPassRepeat}
            onChange={formik.handleChange}
          />
        </div>
      </div>

      {Object.values(formik.errors).length
        ? Object.values(formik.errors).map((single, ix) => (
            <p className="mb-3 text-warning" key={ix}>
              {single}
            </p>
          ))
        : null}

      <Button type="submit" disabled={loading || !formik.isValid}>
        {loading ? "Aktualizowanie..." : "Aktualizuj"}
      </Button>
    </form>
  )
}

export default MyAccountDetailsFormPass
